var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "expedient-actions" },
    [
      _c("SpinnerLayerComponent", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showSpinner,
            expression: "showSpinner",
          },
        ],
        staticClass: "spinner-layer",
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showSpinner,
              expression: "!showSpinner",
            },
          ],
        },
        [
          !_vm.showAddAction
            ? [
                _vm.totals && _vm.totals.length
                  ? _c("LfTotalsComponent", {
                      attrs: { items: _vm.parsedTotal },
                    })
                  : _vm._e(),
                _vm.gridConfiguration
                  ? _c("GridTableComponent", {
                      ref: "grid",
                      attrs: {
                        itemsData: _vm.gridData,
                        gridConfiguration: _vm.gridConfiguration,
                        title: _vm.title,
                        toolbarOptions: _vm.customToolbarOptions,
                        contextMenuItems: _vm.contextMenuItemsActionsExpMixin,
                        listName: _vm.listName,
                        context: _vm.actionContext,
                        showHeader: false,
                        isInTab: "",
                        checkboxSelectColumn: "",
                        showFirstColumn: false,
                      },
                      on: {
                        cellClicked: _vm.onCellClicked,
                        contextMenuBeforeOpen:
                          _vm.customOnContextMenuBeforeOpen,
                        contextMenuClicked: _vm.onContextMenuClicked,
                        toolbarClicked: _vm.onToolbarClicked,
                        gridTableFilter: _vm.onGridTableFilter,
                        selectedRecords: _vm.onSelectedRecords,
                      },
                    })
                  : _vm._e(),
                _vm.changeStatusDialog
                  ? _c("ChangeStatusDialogComponent", {
                      attrs: {
                        showDialog: _vm.changeStatusDialog,
                        selection: _vm.gridSelection,
                      },
                      on: { close: _vm.onStatusDialogClose },
                    })
                  : _vm._e(),
                _vm.billableDialog
                  ? _c("BillableDialogComponent", {
                      attrs: {
                        showDialog: _vm.billableDialog,
                        selection: _vm.gridSelection,
                      },
                      on: { close: _vm.onBillableDialogClose },
                    })
                  : _vm._e(),
                _vm.noBillableDialog
                  ? _c("NoBillableDialogComponent", {
                      attrs: {
                        showDialog: _vm.noBillableDialog,
                        selection: _vm.gridSelection,
                      },
                      on: { close: _vm.onNoBillableDialogClose },
                    })
                  : _vm._e(),
              ]
            : _c(
                "div",
                [
                  _c("TabHeaderComponent", {
                    attrs: {
                      buttons: _vm.buttons,
                      showKebabMenu: _vm.showKebabMenu,
                      title: _vm.getTitle,
                    },
                    on: {
                      closeForm: _vm.onCloseForm,
                      saveForm: _vm.onSaveForm,
                      removeItem: _vm.onRemoveItem,
                      executeAction: _vm.executeAction,
                    },
                  }),
                  _c("TabsComponent", {
                    ref: "tabsComponent",
                    staticClass: "tabs-secondary-styles",
                    attrs: {
                      tabs: _vm.tabs,
                      context: _vm.actionContext,
                      entity: _vm.entity(_vm.actionContext),
                      autoRefreshForm: _vm.autoRefreshForm,
                      permissionsEntityProp: _vm.permissionsEntity,
                      simpleGridContextMenuItemsProp:
                        _vm.simpleGridContextMenuItems,
                      beforeSetComponentProperties:
                        _vm.onBeforeSetComponentProperties,
                    },
                    on: {
                      "save-on-tab-change": _vm.saveOnTabChange,
                      "form-created": _vm.onCreatedForm,
                      "form-mounted": _vm.onInitActionForm,
                      "field-changed": _vm.onActionFieldChanged,
                      "changed-tab": _vm.onTabChange,
                    },
                  }),
                ],
                1
              ),
          _c("ejs-contextmenu", {
            staticClass: "context-menu-component",
            attrs: {
              id: "expedientActionsContextMenuComponent",
              items: _vm.actionsContextMenuItems,
              select: _vm.onActionAddClick,
            },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }